import { Cell, colID, cellID } from './ui/cell'
import { Sheet } from './ui/sheet'
import { render } from './ui/render'

const sheet = new Sheet(100, 10)

var acceptButton: HTMLElement;
var ioButton: HTMLElement;
var formulaInput: HTMLInputElement;
var cellLabel: HTMLElement;
var gridTable: HTMLTableElement;
var selectedCell: Cell;
var importDiv: HTMLElement;
var importTextArea: HTMLTextAreaElement;
var importMode = false;

function load() {
    buildSheet();
    checkGist();
    cacheElements();
    hookUpEvents();
    editCell(sheet.grid[0][0]);
}

function checkGist() {
    if (window.location.hash)
        console.log(window.location.hash);
}

function cacheElements() {
    formulaInput = <HTMLInputElement>document.getElementById("formulaInput");
    acceptButton = document.getElementById("accept");
    ioButton = document.getElementById("io");
    cellLabel = document.getElementById("cellLabel");
    gridTable = <HTMLTableElement>document.getElementById("grid");
    importDiv = document.getElementById("import");
    importTextArea = <HTMLTextAreaElement>document.querySelector("textarea");
}

function hookUpEvents() {
    acceptButton.onclick = (evt) => acceptCell(selectedCell);

    formulaInput.addEventListener("keyup", function (event) {
        if (event.keyCode === 13 && selectedCell) {
            event.preventDefault();
            acceptCell(selectedCell);
        }
    });
    formulaInput.disabled = true;

    ioButton.onclick = (evt) => {
        if (!importMode) {
            openImport();
            importMode = true;
        }
        else {
            closeImport();
            importMode = false;
        }
    }
}

function openImport() {
    importTextArea.value = sheet.export();
    gridTable.style.display = "none";
    importDiv.style.display = "inline";
}

function closeImport() {
    sheet.import(importTextArea.value);
    update();
    gridTable.style.display = "table";
    importDiv.style.display = "none";
}

function acceptCell(cell: Cell) {
    cell.formula = formulaInput.value;
    editCell(cell);
    update();
}

function editCell(cell: Cell) {
    document.querySelectorAll("td").forEach(td => td.classList.remove("edit"))

    cellLabel.textContent = cell.id;
    formulaInput.value = cell.formula;
    formulaInput.disabled = false;
    formulaInput.focus();
    formulaInput.select();

    document.getElementById(cell.id).classList.add("edit");
    selectedCell = cell;
}

function buildSheet() {
    const tableHeadRow = <HTMLTableRowElement>document.getElementById("theadr");
    tableHeadRow.insertCell(-1);
    for (let j = 0; j < sheet.cols; j++) {
        const td = tableHeadRow.insertCell(-1);
        td.textContent = colID(j);
    }

    const tableBody = <HTMLTableSectionElement>document.getElementById("tbody");
    for (let i = 0; i < sheet.rows; i++) {
        const row = tableBody.insertRow(-1);
        const th = row.insertCell(-1);
        th.textContent = (i + 1).toString();
        for (let j = 0; j < sheet.cols; j++) {
            const td = row.insertCell(-1);
            td.id = cellID(i, j);
            td.onclick = function (evt) {
                evt.preventDefault();
                editCell(sheet.grid[i][j]);
            };
        }
    }
}

function update() {
    document.querySelectorAll("td").forEach(td => {
        td.classList.remove("filled");
        td.classList.remove("active");
    })

    const cellValues = sheet.compute();
    sheet.grid.forEach(row =>
        row.forEach(cell => {
            const el = document.getElementById(cell.id)
            if (cell.code.length > 0)
                el.classList.add("active");
            if (cellValues.has(cell.id.toLowerCase())) {
                el.innerHTML =
                    render(cellValues.get(cell.id.toLowerCase()), el.clientWidth);
                if (cell.code.length == 0)
                    el.classList.add("filled");
            }
            else
                el.innerHTML = "";
        }))
}

window.onload = load